import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Like useInventory but for any response shape, with abort + dependency support.
 *   const { data, loading, error, reload } = useResource((signal) => fetchX(filters, signal), [filters]);
 */
export function useResource(fetchFn, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const [token, setToken] = useState(0);

  const fetchRef = useRef(fetchFn);
  fetchRef.current = fetchFn;

  useEffect(() => {
    const ctrl = new AbortController();
    setState((s) => ({ ...s, loading: true, error: null }));

    Promise.resolve(fetchRef.current(ctrl.signal))
      .then((data) => { if (!ctrl.signal.aborted) setState({ data, loading: false, error: null }); })
      .catch((err) => {
        if (ctrl.signal.aborted || err.name === "AbortError") return;
        setState((s) => ({ ...s, loading: false, error: err.message || "Failed to load data." }));
      });

    return () => ctrl.abort();
  }, [token, JSON.stringify(deps)]);

  const reload = useCallback(() => setToken((t) => t + 1), []);
  return { ...state, reload };
}
